valueSideChannel